<template>
  <div class="instagram-simulation">
    <transition name="slide">
      <div
        class="entry"
        v-if="!corrupt"
      >
        <div
          class="media"
          :style="{
            'background-image': `url(${instaNormal})`
          }"
        ></div>
        <div class="content">
          <h3 class="title">
            Hangmat chillings in Nicaragua
          </h3>
          <p class="description">
            🏝 🍹 ⛱.  #genieten #zwaarleven #fml #hahagrapje #travelporn #goodlife
          </p>
        </div>
      </div>
    </transition>
    <div class="behind">
      <div
        class="media"
        :style="{
          'background-image': `url(${instaDepressed})`
        }"
      ></div>
      <div class="content content--corrupt">
        <transition name="description">
          <p
            class="description description--corrupt"
            v-if="corrupt"
          >
            Waarom ben ik niet op reis? Het lukt mij niet eens uit bed te komen. #fml #watkunjewel #faler
          </p>
        </transition>
      </div>
    </div>
    <Heart
      @click.native="corruption"
      :corrupt="corrupt"
    ></Heart>
  </div>
</template>

<script>
import media from '@/utils/media'
import { mediaQueryMixin } from '@/mixins'
import Heart from './Heart'
import { trackSocialSimulation } from '@/utils/track'

export default {
  name: 'InstagramSimulation',
  data () {
    return {
      corrupt: false,
      tracked: false
    }
  },
  mixins: [mediaQueryMixin],
  components: {
    Heart
  },
  methods: {
    imgSize () {
      return this.mobile ? 'mobile' : 'desktop'
    },
    corruption () {
      this.corrupt = true
      if (!this.tracked) {
        trackSocialSimulation('instagram')
      }
      this.tracked = true
    }
  },
  computed: {
    instaNormal () {
      return media.social.instaNormal[this.imgSize()]
    },
    instaDepressed () {
      return media.social.instaDepressed[this.imgSize()]
    }
  }
}
</script>

<style lang="scss" scoped>
.instagram-simulation {
  background-color: white;
  border-radius: 10px;
  height: 511px;
  position: relative;
  margin: 75px auto 0;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);

  @media (min-width: 768px) {
    margin-top: 100px;
  }
}
.media {
  height: 347px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.content {
  padding: 20px 27px;
  height: 164px;
  overflow: hidden;
  color: $c-dark;
  line-height: 1.5;
  font-size: 18px;
  text-align: left;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;

  &--corrupt {
    background-color: #535252;
    color: white;
    position: relative;

    &:before {
      content: '';
      position: absolute;
      background-image: url(~@/assets/images/blob.png);
      background-size: 485px 331px;
      width: 485px;
      height: 331px;
      background-repeat: no-repeat;
      background-position: top left;
      z-index: 1;
      left: -100px;
      top: -50px;
    }
  }
}
.title {
  font-weight: $fw-semi;
}
.description {
  position: relative;
  z-index: 2;

  &--corrupt {
    transition: all 1600ms ease-in-out 3200ms;
  }
}
.description-enter, .description-leave-to {
  opacity: 0;
  transform: translateY(5px);
}
.behind {
  position: relative;
  z-index: 1;
}
.entry {
  position: absolute;
  z-index: 10;
  top: 0;
  top: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  background-color: white;
  transition: all 600ms ease-in-out 2600ms;
  border-radius: 10px;
  opacity: 1;
  transform-origin: 100% 100%;
}
.slide-enter, .slide-leave-to {
  opacity: 0;
  transform: translate(15px, -15px) rotate(4deg);
}
</style>



// WEBPACK FOOTER //
// src/components/social/InstagramSimulation.vue